import React, { Component } from "react";
import Avatar from "./profile.svg";
import Logo from "../../../../assets/images/bigbox-logo.svg";
import LogoThc from "../../../../assets/images/techno_logo_black.svg";
import { FaUser, FaLock } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { loginUser, logoutUser } from "../../../redux/Actions/authAction";
import { AlertError } from "../../common/Alerts";
import HistoryRedirect from "../../../helpers/HistoryRedirect";
import { colors } from "../../../utils/colors";
import { getDomainIdentifier } from "../../../helpers/getDomainIdentifier";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      errorLogin: false,
    };
    this.hasRedirected = false;
  }
  componentDidMount() {
    if (this.props.auth.isAuthenticated && !this.hasRedirected) {
      if (!this.props.auth.user.email) {
        if (!this.props.auth.user.id) {
          this.props.logoutUser();
        }
      } else {
        this.hasRedirected = true;
        HistoryRedirect(this.props.auth.user.user_role.permissions, this.props.history);
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isAuthenticated && !this.hasRedirected && !this.props.auth.isAuthenticated) {
      if (!nextProps.auth.user.email) {
        if (!nextProps.auth.user.id) {
          this.props.logoutUser();
        }
      } else {
        this.hasRedirected = true;
        HistoryRedirect(nextProps.auth.user.user_role.permissions, this.props.history);
      }
    }
  }

  addClass = (name, value) => {
    let inputName;
    if (name === "username")
      inputName = document.querySelector(".input-div.one");
    if (name === "password")
      inputName = document.querySelector(".input-div.two");

    if (value == "") {
      inputName.classList.remove("focus");
    } else {
      inputName.classList.add("focus");
    }
  };

  handleChange = (e) => {
    this.addClass(e.target.name, e.target.value);
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const variables = {
      user: {
        email: this.state.username,
        password: this.state.password,
      },
    };

    this.props.loginUser(variables, this.props.history);
  };
  render() {
    return (
      <LoginContainer>
        <div className="lg-container">
          <div className="lg-img">
            {getDomainIdentifier() === "thc" ? (
              <img src={LogoThc} />
            ) : (
              <img src={Logo} />
            )}
          </div>
          <AlertError title="Prisijungimas" alertId={"loginError"} />
          <div className="login-container">
            <form className="lg" onSubmit={this.onSubmit}>
              <img className="lg-avatar" src={Avatar} />
              <h2 className="title">Prisijungimas</h2>
              <div className="input-div one">
                <div className="i">
                  <FaUser />
                </div>
                <div className="div">
                  <h5>Vartotojas</h5>
                  <input
                    type="text"
                    className="input"
                    name="username"
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="input-div two">
                <div className="i">
                  <FaLock />
                </div>
                <div className="div">
                  <h5>Slaptažodis</h5>
                  <input
                    type="password"
                    name="password"
                    className="input"
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
              </div>
              <Link to="#">Pamiršai slaptažodį? </Link>
              <input type="submit" className="logButton" value="Prisijungti" />
            </form>
          </div>
        </div>
      </LoginContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { loginUser, logoutUser })(Login);

const LoginContainer = styled.div`
  .wave {
    position: fixed;
    height: 100%;
    left: 0;
    bottom: 0;
    z-index: -1;
  }

  .lg-container {
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 7rem;
    padding: 0 2rem;
    background-color: #f3f3f3;
  }
  .lg-img {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .lg-img img {
    width: 500px;
  }
  .login-container {
    display: flex;
    align-items: center;
    text-align: center;
  }

  form.lg {
    width: 360px;
  }

  .lg-avatar {
    width: 100px;
  }

  form.lg h2 {
    font-size: 2.9rem;
    text-transform: uppercase;
    margin: 15px 0;
    color: #333;
  }
  .input-div {
    display: grid;
    grid-template-columns: 7% 93%;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #d9d9d9;

    &:after,
    &:before {
      content: "";
      position: absolute;
      bottom: -2px;
      width: 0;
      height: 2px;
      background-color: ${colors['primary']};
      transition: 0.3s;
    }

    &:after {
      right: 50%;
    }
    &::before {
      left: 50%;
    }
    &.focus {
      & .i svg {
        color: ${colors['primary']};
      }
      & div h5 {
        top: -5px;
        font-size: 15px;
      }
      &:after,
      &:before {
        width: 50%;
      }
    }
  }

  .input-div.one {
    margin-top: 0;
  }

  .input-div.two {
    margin-bottom: 4px;
  }

  .i {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .i svg {
    color: #d9d9d9;
    transition: 0.3s;
  }

  .input-div > div {
    position: relative;
    height: 45px;
  }

  .input-div > div h5 {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 18px;
    transition: 0.3s;
  }

  .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555;
  }

  a {
    display: block;
    text-align: right;
    text-decoration: none;
    color: #999;
    font-size: 0.9rem;
    transition: 0.3s;
    &:hover {
      color: ${colors['primary']};
    }
  }

  .logButton {
    display: block;
    width: 100%;
    height: 50px;
    border-radius: 25px;
    margin: 1rem 0;
    font-size: 1.2rem;
    outline: none;
    border: none;
    background-image: linear-gradient(to right, #03B0F7, #03B0F7, #03B0F7);
    cursor: pointer;
    color: #fff;
    background-size: 200%;
    transition: 0.5s;
    &:hover {
      background-position: right;
    }
  }

  @media screen and (max-width: 1050px) {
    .lg-container {
      grid-gap: 5rem;
    }
  }

  @media screen and (max-width: 1000px) {
    form.lg {
      width: 290px;
    }

    form.lg h2 {
      font-size: 2.4rem;
      margin: 8px 0;
    }
    .lg-img img {
      width: 400px;
    }
  }

  @media screen and (max-width: 900px) {
    .lg-img {
      display: none;
    }
    .lg-container {
      grid-template-columns: 1fr;
    }
    .wave {
      display: none;
    }
    .login-container {
      justify-content: center;
    }
  }
`;
